import { useEffect, useState } from "react";
import { Link, Route, Routes, useLocation } from "react-router-dom";
import styles from "./Dashboard.module.css";
// import { LuConstruction } from "react-icons/lu";
import Faturas from "./Faturas/Faturas";
import Timeline from "./Timeline/Timeline";
import Aplicacoes from "./Aplicacoes/Aplicacoes";
import axios from "axios";
import { Navigate } from "react-router-dom";
import Admin from "./Admin/Admin";
import Logs from "./Admin/Logs/Logs";
import Usuarios from "./Admin/Usuarios/Usuarios";
import FaturasAdmin from "./Admin/Faturas/FaturasAdmin";
import FaturaAdmin from "./Admin/Faturas/FaturaAdmin/FaturaAdmin";
import Cupoes from "./Admin/Cupoes/Cupoes";
import Planos from "./Admin/Planos/Planos";
import Vendas from "./Admin/Vendas/Vendas";
import Conta from "./Conta/Conta";
import Usuario from "./Admin/Usuarios/Usuario/Usuario";
import Plano from "./Admin/Planos/Plano/Plano";
import load from "../../Images/loading.gif";
import Cupao from "./Admin/Cupoes/Cupao/Cupao";
import Venda from "./Admin/Vendas/Venda/Venda";
import Pagamentos from "./Admin/Pagamentos/Pagamentos";
import Aplicacao from "./Aplicacoes/Aplicacao/Aplicacao";


function Dashboard() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const isAdminPage = location.pathname.startsWith("/dashboard/admin");
    const isAppPage = location.pathname.startsWith("/dashboard/aplicacoes/");

    useEffect(() => {
        axios.get("https://eclipsebots.com/api/profile", { withCredentials: true })
            .then((res) => {
                setUser(res.data);
                setLoading(false);
            })
            .catch(() => {
                setUser(null);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    if (!user) {
        return <Navigate to="/" />;
    }

    const getRoleColor = (role) => {
        switch (role) {
            case "Administrador": return "#F1C40F";
            case "Gerente": return "#F34343";
            case "Developer": return "#FF0000";
            case "Suporte": return "#3498DB";
            case "Parceiro": return "#E74C3C";
            case "Cliente": return "#FF0000";
            case "Beta": return "#FF980E";
            case "Booster": return "#F47FFF";
            case "Membro": return "#4dff88";
            default: return "#ccc";
        }
    };

    const staffRoles = ["Administrador", "Gerente", "Developer", "Suporte"];
    const isStaff = staffRoles.includes(user.role)

    if (isAdminPage && !isStaff) {
        return <Navigate to="/dashboard" />;
    }
    if (isAppPage) {
        return (
            <Routes>
                <Route path="aplicacoes/:appId/*" element={<Aplicacao user={user} />} />
            </Routes>
        );
    }

    const getPageTitle = (pathname) => {
        const mainPagesMap = {
            "/dashboard": "Aplicações",
            "/dashboard/aplicacoes": "Aplicações",
            "/dashboard/timeline": "Timeline",
            "/dashboard/faturas": "Faturas",
            "/dashboard/conta": "Conta",
        };

        const adminPagesMap = {
            "/dashboard/admin": "Logs",
            "/dashboard/admin/logs": "Logs",
            "/dashboard/admin/usuarios": "Usuários",
            "/dashboard/admin/cupoes": "Cupões",
            "/dashboard/admin/faturas": "Faturas",
            "/dashboard/admin/planos": "Planos",
            "/dashboard/admin/vendas": "Vendas",
            "/dashboard/admin/pagamentos": "Pagamentos",
        };


        if (pathname.startsWith("/dashboard/aplicacoes/")) {
            const parts = pathname.split('/').filter(Boolean);
            const idIndex = parts.indexOf('aplicacoes') + 1;
            const appId = parts[idIndex];

            if (appId) {
                return `Detalhes da Aplicação #${appId}`;
            }
            return "Detalhes da Aplicação";
        }
        if (pathname.startsWith("/dashboard/admin/usuarios/")) {
            const parts = pathname.split('/').filter(Boolean);
            const idIndex = parts.indexOf('usuarios') + 1;
            const userId = parts[idIndex];
            if (userId) {
                return `Usuário #${userId}`;
            }
            return "Detalhes do Usuário";
        }
        if (pathname.startsWith("/dashboard/admin/faturas/")) {
            const parts = pathname.split('/').filter(Boolean);
            const idIndex = parts.indexOf('faturas') + 1;
            const invoiceId = parts[idIndex];
            if (invoiceId) {
                return `Fatura #${invoiceId}`;
            }
            return "Detalhes da Fatura";
        }
        if (pathname.startsWith("/dashboard/admin/cupoes/")) {
            const parts = pathname.split('/').filter(Boolean);
            const idIndex = parts.indexOf('cupoes') + 1;
            const couponCode = parts[idIndex];
            if (couponCode) {
                return `Cupão: ${couponCode}`;
            }
            return "Detalhes do Cupão";
        }
        if (pathname.startsWith("/dashboard/admin/planos/")) {
            const parts = pathname.split('/').filter(Boolean);
            const idIndex = parts.indexOf('planos') + 1;
            const planoId = parts[idIndex];
            if (planoId) {
                return `Plano #${planoId}`;
            }
            return "Detalhes do Plano";
        }
        if (pathname.startsWith("/dashboard/admin/vendas/")) {
            const parts = pathname.split('/').filter(Boolean);
            const idIndex = parts.indexOf('vendas') + 1;
            const vendaId = parts[idIndex];
            if (vendaId) {
                return `Venda #${vendaId}`;
            }
            return "Detalhes da Venda";
        }

        if (isAdminPage) {
            return adminPagesMap[pathname] || "Painel Admin";
        } else {
            return mainPagesMap[pathname] || "Dashboard";
        }

    }

    const currentPageName = getPageTitle(location.pathname);

    return (
        <div className={styles.content}>
            <div className={`${styles.size} ${styles.dashboard}`}>

                <div className={styles.pageCurrent}>
                    <Link to={`/dashboard`}>
                        Painel de Controlo
                    </Link>
                    {isAdminPage && (
                        <span>
                            <span className={styles.separator}>{">"}</span>
                            <Link to={`/dashboard/admin`}>
                                Administrador
                            </Link>
                        </span>
                    )}
                    <span className={styles.separator}>{">"}</span>
                    <span className={styles.currentPage}>
                        {currentPageName}
                    </span>
                </div>
                <div className={styles.dashNavContent}>
                    <div className={styles.main}>
                        <div className={styles.image}>
                            <img src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.${user.avatar.startsWith("a_") ? "gif" : "png"}`} alt="Imagem de Perfil" />
                        </div>
                        <div className={styles.data}>
                            <div className={styles.name}>{user.username}</div>
                            <div className={styles.id}>{user.id}</div>
                            <div className={styles.role} style={{ backgroundColor: getRoleColor(user.role), color: user.role === "user" ? "black" : "white" }}>{user.role}</div>
                            {!isAdminPage && (
                                <div className={styles.badges}>Nenhum emblema</div>
                            )}
                        </div>
                    </div>
                    <div className={styles.pages}>
                        {!isAdminPage && (
                            <span className={styles.pages}>
                                <Link to="/dashboard/aplicacoes"><div className={`${styles.page} ${location.pathname === "/dashboard/aplicacoes" || location.pathname === "/dashboard/" || location.pathname === "/dashboard" ? styles.active : ""}`}>Aplicações</div></Link>
                                <Link to="/dashboard/timeline"><div className={`${styles.page} ${location.pathname === "/dashboard/timeline" ? styles.active : ""}`}>Timeline</div></Link>
                                <Link to="/dashboard/faturas"><div className={`${styles.page} ${location.pathname === "/dashboard/faturas" ? styles.active : ""}`}>Faturas</div></Link>
                                <Link to="/dashboard/conta"><div className={`${styles.page} ${location.pathname === "/dashboard/conta" ? styles.active : ""}`}>Conta</div></Link>
                                {isStaff && (
                                    <span>
                                        <Link to="/dashboard/admin"><div className={`${styles.page} ${location.pathname === "/dashboard/admin" ? styles.active : ""}`}>Painel Admin</div></Link>
                                    </span>
                                )}
                            </span>
                        )}

                        {isStaff && isAdminPage && (
                            <span className={styles.pages}>
                                <Link to="/dashboard/admin/"><div className={`${styles.page} ${location.pathname === "/dashboard/admin/logs" || location.pathname === "/dashboard/admin" || location.pathname === "/dashboard/admin/" ? styles.active : ""}`}>Logs</div></Link>
                                <Link to="/dashboard/admin/usuarios"><div className={`${styles.page} ${(location.pathname).startsWith("/dashboard/admin/usuarios") ? styles.active : ""}`}>Usuários</div></Link>
                                <Link to="/dashboard/admin/cupoes"><div className={`${styles.page} ${(location.pathname).startsWith("/dashboard/admin/cupoes") ? styles.active : ""}`}>Cupões</div></Link>
                                <Link to="/dashboard/admin/faturas"><div className={`${styles.page} ${(location.pathname).startsWith("/dashboard/admin/faturas") ? styles.active : ""}`}>Faturas</div></Link>
                                <Link to="/dashboard/admin/planos"><div className={`${styles.page} ${(location.pathname).startsWith("/dashboard/admin/planos") ? styles.active : ""}`}>Planos</div></Link>
                                <Link to="/dashboard/admin/vendas"><div className={`${styles.page} ${(location.pathname).startsWith("/dashboard/admin/vendas") ? styles.active : ""}`}>Vendas</div></Link>
                                <Link to="/dashboard/admin/pagamentos"><div className={`${styles.page} ${(location.pathname).startsWith("/dashboard/admin/pagamentos") ? styles.active : ""}`}>Pagamentos</div></Link>
                            </span>
                        )}
                    </div>
                    <div className={styles.pageContent}>
                        <Routes>
                            <Route index element={<Aplicacoes />} />
                            <Route path="aplicacoes" element={<Aplicacoes user={user} />} />
                            <Route path="timeline" element={<Timeline user={user} />} />
                            <Route path="faturas" element={<Faturas user={user} />} />
                            <Route path="conta" element={<Conta user={user} />} />

                            <Route path="admin" element={<Admin />}>
                                <Route index element={<Logs />} />
                                <Route path="logs" element={<Logs />} />
                                <Route path="usuarios" element={<Usuarios />} />
                                <Route path="usuarios/:id" element={<Usuario />} />
                                <Route path="faturas" element={<FaturasAdmin />} />
                                <Route path="faturas/:invoiceId" element={<FaturaAdmin />} />
                                <Route path="cupoes" element={<Cupoes user={user} />} />
                                <Route path="cupoes/:coupon_code" element={<Cupao />} />
                                <Route path="planos" element={<Planos />} />
                                <Route path="planos/:id" element={<Plano />} />
                                <Route path="vendas" element={<Vendas />} />
                                <Route path="vendas/:id" element={<Venda />} />
                                <Route path="pagamentos" element={<Pagamentos />} />
                            </Route>
                        </Routes>
                    </div>
                </div>

            </div>
        </div>
    );
}

// <div className={styles.content}>
//     <div className={`${styles.size} ${styles.dashboard}`}>
//         <div className={styles.center}>
//             <LuConstruction />
//             <div className={styles.text}>EM CONSTRUÇÃO</div>
//         </div>
//     </div>
// </div>

export default Dashboard;